import Swiper from "swiper";

const pastReportsSwiper = function () {
  const swiper = new Swiper('.nbi-index-past-reports .swiper', {
    navigation: false,
    slidesPerView: 1.5,
    // freeMode: false,
    breakpoints: {
      782: {
        slidesPerView: 4,
      },
      700: {
        slidesPerView: 3.5,
      },
      641: {
        slidesPerView: 2.8,
      },
    },
  });
}

export { pastReportsSwiper };
